const ENVIRONMENTS = ['production', 'staging', 'sandbox'];

export default class AccessToken {
  token;
  environment;

  constructor(token, environment = 'production') {
    if (!token) {
      throw new Error('Token is required');
    }
    if (!ENVIRONMENTS.includes(environment)) {
      throw new Error(`Invalid environment: ${environment}. Must be one of ${ENVIRONMENTS.join(', ')}`);
    }

    this.token = token;
    this.environment = environment;
  }

  get isProduction() {
    return this.environment === 'production';
  }
  get isSandbox() {
    return this.environment === 'sandbox';
  }
  get isStaging() {
    return this.environment === 'staging';
  }
}
